import cookies from 'js-cookie';
import { versionCompare } from '@kibt/web-utils/version';
import { isYodaEnv } from '@/utils/env';
import { yoda } from './yoda';
import getLiveRoomInfo from '@/utils/liveRoomInfo';

type FullDefaultOptions = {
    title?: string; // 默认标题
    titleColor?: string; // title颜色
    topBarPosition?: string; // 顶部栏风格 isFullScreen ? fixed : default
    topBarBgColor?: string; // 顶部栏背景颜色
    topBarBorderColor?: string; // 顶栏下边线的颜色
    statusBarColorType?: string; // 电池栏文字颜色
    webviewBgColor?: string; // webview背景颜色
    onSlideBack?: string; // 右滑返回行为定义
}

type HalfDefaultOptions = {
    launchType: number;
    corner: number;
    height: number;
    fullScreen: string;
    hideToolbar: Boolean;
    enableProgress: Boolean;
    url: string;
};

const halfDefault = {
    launchType: 1,
    corner: 16,
    height: 628,
    fullScreen: '0',
    hideToolbar: true,
    enableProgress: true, // 安卓
    url: '',
};

const fullDefault = {
    titleColor: '#222222',
};

/**
 * 半屏及全屏情况，打开新的页面
 *
 * @param url 包含全部query参数
 * @param halfOptions 半屏webview桥参数配置
 * @param fullOptions 全屏launchOptions参数配置
 */
export const openPage = async (url: string, halfOptions?: HalfDefaultOptions, fullOptions?: FullDefaultOptions) => {
    if (url.startsWith('/')) {
        url = `${window.location.origin}${url}`;
    }
    if (!isYodaEnv) {
        window.location.href = url;
        return;
    }
    const { isLiving, isAuthorSelf } = getLiveRoomInfo();
    const appver = cookies.get('appver') || '0';
    // 主播侧，安卓半屏桥低版本无法使用
    const canHalfBridge = versionCompare(appver, '6.7.50') >= 0;
    if (isLiving) {
        const sym = url.indexOf('?') === -1 ? '?' : '&';
        // 直播间
        if (isAuthorSelf && !canHalfBridge) {
            // 主播侧低版本
            window.location.href = `${url}${sym}isLiving=true`;
        } else {
            await yoda.ready();
            yoda.component?.loadNewUrlHalfPage({
                ...halfDefault,
                ...(halfOptions || {}),
                url: `${url}${sym}isLiving=true`,
            });
        }
    } else {
        await yoda.ready();
        // 非直播间 打开全屏
        yoda.webview?.open({
            url,
            launchOptions: {
                ...fullDefault,
                ...(fullOptions || {}),
            },
        });
    }
};

/**
 * 点击按钮 关闭页面
*/
export const closePage = async () => {
    if (!isYodaEnv) {
        window.history.go(-1);
        return;
    }
    await yoda.ready();
    // android：6.4.40   ios：6.5.10
    yoda.component.backOrCloseWeb({
        closeWeb: false, // true: 直接关闭webview；false: 先back，不能back再关闭webview；默认值：true
    });
};


